import type { CSSProperties } from "react";
import { Toaster } from "sonner";
import { useTheme } from "./theme-provider";

// every toast sits on the same quiet grey card as the rest of the app; only
// its icon carries the color, a green check, a red cross, an amber warning
const NEUTRAL_TOAST = {
  "--normal-bg": "var(--background-neutral)",
  "--normal-border": "var(--border)",
  "--normal-text": "var(--foreground)",
} as CSSProperties;

export function ThemedToaster() {
  const { resolvedTheme } = useTheme();

  return (
    <Toaster
      position="top-right"
      theme={resolvedTheme === "light" ? "light" : "dark"}
      style={NEUTRAL_TOAST}
      toastOptions={{
        classNames: {
          success: "[&_[data-icon]]:text-green-500",
          error: "[&_[data-icon]]:text-red-500",
          warning: "[&_[data-icon]]:text-amber-500",
          info: "[&_[data-icon]]:text-blue-500",
        },
      }}
    />
  );
}
